// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

export const BlogMenuFragmentDoc = `
    fragment blogMenu on PostCategory {
  id
  name
  slug
  children(locale: $locale) {
    id
    name
    slug
  }
}
    `;